module.exports = __webpack_public_path__ + "media/src/website/images/locations/tittmoning/01-f33223f726a631fb3639bf4a21fb7e60.jpg";